import Logo from "./logo.png";
import Bamba from "./partners/bamba.jpg";
import DestinationServices from "./partners/destinationservices.jpg";
import GAdventure from "./partners/gadventures.jpg";
import Interpid from "./partners/intrepid.jpg";
import KRS from "./partners/krs.png";
import Tanapa from "./partners/tanapa.png";
import Tato from "./partners/tato.png";
import Tatto from "./partners/tatto-logo.png";
import Topdeck from "./partners/topdeck.jpg";
import Trafalgar from "./partners/trafalgar.jpg";
import TravelTalk from "./partners/travel-talk.jpg";
import TrutTravels from "./partners/trutravels.jpg";

export { Logo };

export const partners = [
  { src: DestinationServices },
  { src: GAdventure },
  { src: Interpid },
  { src: KRS },
  { src: Tanapa },
  { src: Tato },
  { src: Tatto },
  { src: Topdeck },
  { src: Trafalgar },
  { src: TravelTalk },
  { src: TrutTravels },
  { src: Bamba },
];
